import firebase from '@/firebase'
const db = firebase.firestore()
const storage = firebase.storage().ref()
import { config } from '@/firebase.js'
import { FS_COLLECTIONS } from '@/firebase.js'
import { TIPO_PERFIL } from '@/constantes/usuarios.js'
import errors from "@/errors";
import {PRODUCCION, URL_CLUDSF} from '@/constantes/environment'
import axios from "axios";
//var firebaseAlterno = null
var cargadorIndiceUsuarios = null
const store = {
  state: {
    indiceUsuarios: []
    // TODO: Eliminar de forma segura usuarios []
    //  usuarios: [],
    //usuario: {}
  },
  getters: {
    indiceUsuarios(state) {
      return state.indiceUsuarios
    },
    usuarios(state) {
      return state.usuarios
    },
    usuarioPorID(state) {
      return id => state.usuarios.find(usuario => usuario.id === id)
    }
  },
  mutations: {
    ASIGNA_INDICE_USUARIOS(state, usuarios) {
      state.indiceUsuarios = usuarios
    },
    /* ASIGNA_USUARIO(state, usuario) {
      state.usuario = usuario
    }, */
    agregarUsuario(state, usuario) {
      state.usuarios.push(usuario)
    }
  },
  actions: {
    // INICIO INDICES
    cargaIndiceUsuarios({ commit, getters }) {
      if (getters.indiceUsuarios === null) {
        if (typeof cargadorIndiceUsuarios === 'function') {
          cargadorIndiceUsuarios()
        }
        cargadorIndiceUsuarios = null
        console.log('getters.cargadorIndiceUsuarios === null')
      }
      if (cargadorIndiceUsuarios === null) {
        ///Franquicias/BF2Iny6XE5EeQLqPErQv/Indices/Propietarios
        console.log('getters.franquicia.id: ' + getters.franquicia.id)
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.INDICES)
          .doc(FS_COLLECTIONS.USUARIOS)
        cargadorIndiceUsuarios = docPath.onSnapshot(doc => {
          console.log('Current data: ', doc.data())
          var usuarios = doc.data()
          let indiceSucursales = getters.indiceSucursales
          for (var keyUs in usuarios) {
            let us = usuarios[keyUs]
            us.sucursales = []
            for (var k in indiceSucursales) {
              if (!us.ids_sucursales) {
                continue
              }
              if (us.ids_sucursales.includes(k)) {
                us.sucursales.push(indiceSucursales[k])
              }
            }
          }

          commit('ASIGNA_INDICE_USUARIOS', usuarios)
        })
      }
    },
    cargaInfoUsuario({ commit }, idUsuario) {
      //console.log('1 store idUsuario: ' + idUsuario)
      return new Promise((resolve, reject) => {
        let docPath = db.collection(FS_COLLECTIONS.USUARIOS).doc(idUsuario)
        docPath
          .get()
          .then(doc => {
            //console.log('2 Usuario Cargado: ', doc.data().id)
            //console.log(doc.data())
            //commit('ASIGNA_USUARIO', doc.data())

            //return doc.data()
            resolve(doc.data())
          })
          .catch(error => {
            resolve('pruebas')
            console.log('3 error store: ' + error)
            reject()
          })
      })
      //return cargadorPropietario
    },
    // FIN INDICES
    agregarNuevoUsuario({ getters }, usuario) {
      var firebaseAlterno = null
      let apps = firebase.apps
      // Revisamos si ya esta dada de alta
      for (let k in apps) {
        if (apps[k].name === 'Alterno') {
          // Si esta dado de alta la asignamos a firebaseAlterno
          firebaseAlterno = apps[k]
        }
      }
      // Si no hubo ningun ainstancia creamos una nueva
      if (firebaseAlterno === null) {
        firebaseAlterno = firebase.initializeApp(config, 'Alterno')
      }
      // FIXME: Manejo de diferentes errores
      //console.log('firebase.app.length: ' + firebase.app.length)
      //console.log(usuario)
      usuario.id_corporativo = getters.corporativo.id
      return new Promise(async(resolve, reject) => {
        const dataJsonUsuario = JSON.stringify(usuario);

        let urlCrearUsuario = URL_CLUDSF+'/wsCrearEmpleado';
        
        const res = await axios.post(urlCrearUsuario, dataJsonUsuario, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        console.log('respuesta firebase',res.data);

        if(res.data.error){
          if(res.data.error.code == "auth/email-already-exists"){
            this.cargandoFormulario = false;
            this.loader = false;
            //alert('Este correo ya esta registrado.');
            reject(errors(res.data.error));
          }
        }

        if(!res.data.status){
          //alert('Ocurrio un error avisa al administrador.');
          reject(false);
        }

        const userId = res.data.id

        resolve(userId)
      })
    },



    agregarNuevoCliente({ getters }, usuario) {
      var firebaseAlterno = null
      let apps = firebase.apps
      // Revisamos si ya esta dada de alta
      for (let k in apps) {
        if (apps[k].name === 'Alterno') {
          // Si esta dado de alta la asignamos a firebaseAlterno
          firebaseAlterno = apps[k]
        }
      }
      // Si no hubo ningun ainstancia creamos una nueva
      if (firebaseAlterno === null) {
        firebaseAlterno = firebase.initializeApp(config, 'Alterno')
      }
      // FIXME: Manejo de diferentes errores
      //console.log('firebase.app.length: ' + firebase.app.length)
      //console.log(usuario)

      return new Promise((resolve, reject) => {
        let dbAlterno = firebaseAlterno.firestore()
        firebaseAlterno
          .auth()
          .createUserWithEmailAndPassword(usuario.email, usuario.password)
          .then(() => {
            var user = firebaseAlterno.auth().currentUser
            delete usuario.password
            usuario.id = user.uid
            //usuario.id_franquicia = getters.franquicia.id
            usuario.id_corporativo = getters.corporativo.id
            usuario.rol = 'Admin'
            usuario.estatus = { estatus: 'Activo' }
            usuario.foto = ''

            console.log(' getters.corporativo.id: ' + getters.corporativo.id)

            let perfil = {
              es_admin: true,
              es_empleado: false,
              estatus: 'Activo',
              id: user.uid,
              id_corporativo: getters.corporativo.id,
              //id_franquicia: getters.franquicia.id,
              tipo: TIPO_PERFIL.USUARIO
            }

            dbAlterno
              .collection(FS_COLLECTIONS.PERFILES)
              .doc(user.uid)
              .set(perfil)

            dbAlterno
              .collection(FS_COLLECTIONS.USUARIOS)
              .doc(user.uid)
              .set(usuario)
              .then(doc => {
                resolve(user.uid)
              })
          })
          .catch(error => {
            console.log('error creando usuario: ' + error.message)
            reject(error)
          })
      })
    },



    
    // FIXME: Actualización de eliminación de usuario
    eliminarUsuario({}, usuarioID) {
      return db
        .collection('Usuarios')
        .doc(usuarioID)
        .delete()
    },
    actualizarUsuario({}, usuario) {
      // FIXME: Actualización de contraseña e email
      if (usuario.password === '' || usuario.password === undefined) {
        delete usuario.password
      } else {
        delete usuario.password
      }

      return db
        .collection('Usuarios')
        .doc(usuario.id)
        .update({
          ...usuario
        })
    },
    actualizarUsuarioSet({}, usuario) {
      // FIXME: Actualización de contraseña e email
      if (usuario.password === '' || usuario.password === undefined) {
        delete usuario.password
      } else {
        delete usuario.password
      }

      return db
        .collection('Usuarios')
        .doc(usuario.id)
        .set({
          ...usuario
        }, {merge: true})
    },
    recuperarContrasenia({}, correo) {
      console.log('2 correo: ' + correo)
      var auth = firebase.auth()
      return auth.sendPasswordResetEmail(correo)
    },
    subirArchivoUsuario({getters}, archivo) {
      var uid = firebase.auth().currentUser.uid
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2
      //foto.jpg
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2/foto.jpg
      return new Promise((resolve, reject) => {
        storage
          .child(`Franquicias/${getters.franquicia.id}/Usuarios/${archivo.idUser}/${archivo.name}`)
          .put(archivo)
          .then(uploadTaskSnapshot => {
            uploadTaskSnapshot.ref
              .getDownloadURL()
              .then(url => {
                resolve(url)
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    },
    /*subirFirmaUsuario({getters}, archivo) {
      var uid = firebase.auth().currentUser.uid
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2
      //foto.jpg
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2/foto.jpg
      return new Promise((resolve, reject) => {
        storage
          .child(`Franquicias/${getters.franquicia.id}/Usuarios/${archivo.idUser}/firma/${archivo.name}`)
          .put(archivo)
          .then(uploadTaskSnapshot => {
            uploadTaskSnapshot.ref
              .getDownloadURL()
              .then(url => {
                resolve(url)
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    },*/
    numeroDeUsuario({}, idCorporativo){
      return new Promise((resolve, reject) => {
        let contador = 0;
        let docPath = db
          .collection(FS_COLLECTIONS.USUARIOS)
          .where("id_corporativo", "==", idCorporativo)
          .where("estatus.estatus", "==", 'Activo');
        docPath.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
              if(doc.data().info.cargo !== 'responsable'){
                contador++;
              }
              //console.log(doc.id, ' => ', doc.data());
          });

          resolve(contador)
      });
      })
    },


  }//fin actions
}

export default store



// WEBPACK FOOTER //
// ./src/store/usuarios/usuarios.js